import { defineComponent, onMounted } from 'vue';
import ServiceBlockedModalCode from './service-blocked-modal.code';

export default defineComponent({
	name: 'ServiceBlockedModal',
	props: {
		reason: {
			type: String,
			required: true
		}
	},
	setup: (props) => {
		const code = new ServiceBlockedModalCode(props.reason);
		
		onMounted(() => {
			code.mounted();
		});
		
		return code;
	}
});
